import React, { CSSProperties } from 'react'
import classNames from 'classnames'
import { InView } from 'react-intersection-observer'
import { mergeQueryParameters } from '@/utils/UriBuilder'
import { formatYouTubeUrl } from '@/utils/url'

interface EmbeddedVideoProps {
  className?: string
  title?: string
  url: string
  iframeStyle?: CSSProperties
  autoPlayInView?: boolean
}

export const EmbeddedVideo: React.FC<EmbeddedVideoProps> = ({ className, title, url, iframeStyle, autoPlayInView }) => {
  const [inView, setInView] = React.useState(false)
  const modifiedUrl = formatYouTubeUrl(url)

  return (
    <span className={classNames('block aspect-w-16 aspect-h-9 bg-black rounded-2xl', className)}>
      <InView triggerOnce onChange={(inView) => autoPlayInView && setInView(inView)}>
        <iframe
          width="100%"
          height="100%"
          src={mergeQueryParameters(modifiedUrl, { rel: '0', autoplay: inView ? '1' : '0', mute: inView ? '1' : '0' })}
          title={title}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          style={iframeStyle}
        />
      </InView>
    </span>
  )
}
